import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Form, TextArea } from "../../../components/forms";
import DocumentUpload from "./DocumentUpload";
import { uploadOrderFile } from "../../../services/fileService";
import parseError from "../../../utils/errorUtils";
import { useAddOrderNotesMutation } from "../../../services/orderService";
import LoadingSpinner from '../../../components/loadingSpinner/LoadingSpinner';

const AdditionalInfoForm = () => {
  const navigate = useNavigate();
  const [addOrderNote] = useAddOrderNotesMutation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [note, setNote] = useState("")
  const [numberOfDocuments, setNumberOfDocuments] = useState(0)

  const handleNavigate = () =>
    navigate("/onboarding/eligibility-flow/id-upload", { replace: true });

  const orderId = localStorage.getItem("orderId");

  const [initialValues] = useState({});

  const handleSubmit = async (values) => {
    try {
      let response;
      const data = {
        type: "PRESENTING_COMPLAINT",
        description: note,
      };

      setIsSubmitting(true);
      const res = note !== "" ? await addOrderNote({ orderId, values: data }) : null;

      var formData = new FormData();

      for (const fileData of values.documents ?? []) {
        formData.append(
          "files",
          fileData,
          `${fileData.type}.${fileData.name.split(".")[1]}`
        );
        formData.append("type", "Other supporting document");
        response = await uploadOrderFile(orderId, formData);
        formData.delete("files");
        formData.delete("type");
      }

      if (res?.error) {
        setIsSubmitting(false);
        toast.error(parseError(res.error, "Couldn't add note"));
      } else if (response?.error) {
        setIsSubmitting(false);
        toast.error(parseError(response.error, "Couldn't upload document"));
      } else {
        setIsSubmitting(false);
        (Object.keys(values).length !== 0 && !isMobile) && toast.success("Successfully saved");
        (numberOfDocuments !== 0 || note.length !== 0) && handleNavigate();
      }
    } catch (e) {
      setIsSubmitting(false);
      console.error(e);
    }
  };

  useEffect(() => {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    setIsMobile(isMobile);
  }, []);

  const validateFiles = (values) => {
    values?.documents && setNumberOfDocuments(values?.documents?.length)
  }

  const checkNote = (e) => {
    setNote(e.target.value)
  }

  return (
    <div className="d-flex flex-column h-100">
      <h4 className="mb-2 fw-bold">Additional details</h4>
      <div className="container px-0 d-flex flex-column justify-content-between">
        <div className="column col-md-12">
          <p className="text-gray-1 mb-3">
            Thanks for securing your appointment with us!{" "}
            <span className="text-black">
              Please share supporting documents with us as this often
              accelerates the approval process!
            </span>{" "}
            This could be things like recent test results, medical history
            summaries, or a list of medications or treatments you have tried.
          </p>
        </div>
      </div>
      <div className="d-flex mt-4 h-100">
        <Form
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize
          className="d-flex"
        >
          <div className="container px-0 d-flex flex-column justify-content-between">
            <div className="column col-md-12 col-lg-12 col-xl-9">
              <div className="row mb-4">
                <div className="col-md-12">
                  <label className="mb-2">
                    Additional documents for the consultant
                  </label>
                  <DocumentUpload
                    name="documents"
                    multiple
                    fileLimit={5}
                    acceptedTypes={["image/png", "image/jpeg", "application/pdf"]}
                    getFiles={validateFiles}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <label className="mb-2">
                    Additional notes for the consultant
                  </label>
                  <TextArea
                    name="notes"
                    placeholder="Type your message"
                    className="p-1 px-3 pt-1 w-100 bg-transparent border card-border rounded custom-placeholder"
                    onChange={checkNote}
                  />
                </div>
              </div>
            </div>
            <div className="column d-flex flex-row justify-content-center justify-content-md-end align-items-center">
              <div className="d-flex flex-column-reverse flex-md-row footer-div px-5 px-md-0 py-4 py-md-0 fixed-single-footer justify-content-md-end">
                <button
                  className="text-primary-600 bg-transparent pt-2 pb-0 px-4 btn-sm w-md-fit h-fit fw-bold border-0 rounded text-nowrap"
                  onClick={handleNavigate}
                >
                  <p className="mb-0 fw-bold fs-6">Upload later</p>
                </button>
                <button
                  className={
                    `bg-primary-600 text-white py-2 px-5 btn-sm w-md-fit h-fit fw-bold fs-6 border-0 rounded text-nowrap
                    ${(numberOfDocuments === 0 && note.length === 0) ? "opacity-50" : "opacity-100"}`
                  }
                  type="submit"
                  disabled={(numberOfDocuments === 0 && note.length === 0) || isSubmitting}
                >
                  {isSubmitting ? <LoadingSpinner loadingText="Continue" /> : "Continue"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default AdditionalInfoForm;
